export default __webpack_public_path__ + "static/media/icon-eye-outline.8236b909.svg";